export default [
  {
    path: '/admin/horizon',
    name: 'horizon',
    component: () => import('@/views/modules/admin/Horizon'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Horizon' }
      ]
    },
  }, 
  {
    path: '/admin/telescope',
    name: 'telescope',
    component: () => import('@/views/modules/admin/Telescope'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Telescope' }
      ]
    },
  }, 
  
]